import gql from 'graphql-tag';

export default fields => gql`
mutation ($id: String!, $version: Int!) {
    deleteCampaign (input: { id: $id, version: $version }) {
        __typename
        ${[...['id', 'name'].concat(fields)]}
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Campaigns/DeleteMutation.js